<template>
  <v-btn block color="default" :to="{ name: 'AuthHome' }">
    <v-icon small>{{ mdiArrowLeft }}</v-icon>
    {{ $t('common.back')}}
  </v-btn>
</template>

<script>
import { mdiArrowLeft } from '@mdi/js';

export default {
  data() {
    return {
      mdiArrowLeft,
    };
  },
};
</script>
